import { APICore } from "./apiCore";

const api = new APICore();

const criarProntuario = (params: any) => {
    return api.create("/prontuario", params);
};

const atualizarProntuario = (
    id: string | number,
    params: any
) => {
    return api.update(`/prontuario/${id}`, params);
};

const atualizarResponsavelProntuario = (
    prontuariosId: string[] | number[],
) => {
    return api.update(`/responsavel-checked`, { prontuariosId });
}

export { criarProntuario, atualizarProntuario, atualizarResponsavelProntuario };
